import { create } from 'zustand'

export interface WargameAccount {
  id: string
  email: string
}

interface AuthState {
  account: WargameAccount | null
  accessToken: string | null
  /** True while `bootstrapSession()` is checking for a silently-restorable session on app load. */
  restoring: boolean
  setSession: (account: WargameAccount, accessToken: string) => void
  clear: () => void
  setRestoring: (v: boolean) => void
}

/**
 * NOT persisted — the access token is short-lived by design (see
 * atlasAuthClient's `bootstrapSession`, which silently restores a session via
 * the httpOnly refresh cookie on app load instead of stashing the token in
 * localStorage).
 */
export const useAuthStore = create<AuthState>((set) => ({
  account: null,
  accessToken: null,
  restoring: true,
  setSession: (account, accessToken) => set({ account, accessToken }),
  clear: () => set({ account: null, accessToken: null }),
  setRestoring: (v) => set({ restoring: v }),
}))
